import React, { Component } from 'react';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import compose from 'recompose/compose';
import { withRouter } from 'react-router-dom';
import { closeModal } from 'src/actions/modals';

import { withCurrentUser } from 'src/components/withCurrentUser';
import ModalContainer from '../modalContainer';
import { PrimaryButton } from 'src/components/button';
import { modalStyles } from '../styles';
import { TextArea } from '../../formElements';
import { addToastWithTimeout } from 'src/actions/toasts';
import EmojiPicker from 'src/components/emojiPicker';
import getPresignedPutUrl from 'src/helpers/uploadFile';
import Icon from 'src/components/icon';
// import type { History } from 'react-router-dom';
import getSnippet from 'shared/clients/draft-js/utils/getSnippet';
import { convertTimestampToDate } from 'shared/time-formatting';
import editMessageMutation from 'shared/graphql/mutations/message/editMessage';
import {
  Form,
  Actions,
  Date,
  PreviewMedia,
  RemovePreviewButton,
  PhotoSizeError,
} from './style';

const DATA_TEST_PRE = 'edit-comment-modal-';
class EditCommentModal extends React.Component {
  constructor(props) {
    super();
    const { message } = props;
    const body = JSON.parse(message.content.body);
    const media = body.entityMap[0];

    this.state = {
      comment: getSnippet(body),
      createError: false,
      loading: false,
      showEmojiPicker: false,
      mediaPreview: media && media.data.src,
      mediaFile: null,
      mediaType: media && media.type,
      photoSizeError: '',
    };
  }
  close = () => {
    this.props.dispatch(closeModal());
  };

  edit = async e => {
    e.preventDefault();
    this.setState({ loading: true });

    const { dispatch, editMessage, message } = this.props;
    const { comment } = this.state;
    let body = comment;
    if (this.state.mediaFile) {
      const mediaFile = this.state.mediaFile;
      const fileUrl = await getPresignedPutUrl({
        location: 'post',
        file: mediaFile,
      });
      const uploading = `![${mediaFile.name}](${fileUrl})`;
      if (mediaFile.type === 'video/mp4') {
        body = comment + ' ' + fileUrl;
      } else {
        body = comment + uploading;
      }
    } else if (this.state.mediaPreview) {
      if (this.state.mediaType === 'IMAGE') {
        body =
          comment + `![${this.state.mediaName}](${this.state.mediaPreview})`;
      } else {
        body = comment + ' ' + this.state.mediaPreview;
      }
    }
    const content = {
      body,
    };
    const input = {
      id: message.id,
      content,
      messageType: 'text',
    };
    editMessage(input)
      .then(({ data: { editMessage } }) => {
        if (editMessage && editMessage !== null) {
          this.setState({ loading: false });
          this.props.dispatch(closeModal());
          return dispatch(addToastWithTimeout('success', 'Saved!'));
        } else {
          return dispatch(
            addToastWithTimeout(
              'error',
              "We weren't able to save these changes. Try again?"
            )
          );
        }
      })
      .catch(err => {
        dispatch(addToastWithTimeout('error', err.message));
      });
  };

  closePicker = () => {
    this.setState({ showEmojiPicker: false });
  };
  onSelectEmoji = ({ native }) => {
    this.closePicker();
  };
  showPicker = () => {
    this.setState({ showEmojiPicker: true });
  };

  previewMedia = blob => {
    const reader = new FileReader();
    reader.onload = () => {
      this.setState({
        mediaPreview: reader.result.toString(),
        // isSendingMediaMessage: false,
        mediaFile: blob,
      });
    };
    if (blob) {
      reader.readAsDataURL(blob);
    }
  };

  changeComment = e => {
    const comment = e.target.value;
    this.setState({
      comment,
    });
  };

  renderModalContent() {
    const { message } = this.props;
    const { comment, loading } = this.state;
    return (
      <ModalContainer title="Edit comment" closeModal={this.close}>
        <Date>Published: {convertTimestampToDate(message.timestamp)}</Date>
        <Form>
          <TextArea
            id="comment"
            defaultValue={comment}
            onChange={this.changeComment}
            showAction={true}
            showEmojiPicker={this.showPicker}
            previewMedia={this.previewMedia}
            mediaError={err => {
              this.setState({ photoSizeError: err });
            }}
            testId={`${DATA_TEST_PRE}change-comment`}
          />
          {this.state.photoSizeError && (
            <PhotoSizeError>
              <p>{this.state.photoSizeError}</p>
              <Icon
                onClick={() => this.setState({ photoSizeError: '' })}
                glyph="view-close"
                size={16}
                color={'warn.default'}
              />
            </PhotoSizeError>
          )}
          {this.state.mediaPreview && (
            <PreviewMedia>
              <img src={this.state.mediaPreview} alt="" />
              <RemovePreviewButton
                onClick={() => this.setState({ mediaPreview: '' })}
                data-testid={`${DATA_TEST_PRE}remove-media`}
              >
                <Icon glyph="view-close-small" size={'16'} />
              </RemovePreviewButton>
            </PreviewMedia>
          )}

          <Actions>
            <PrimaryButton
              isLoading={loading}
              onClick={this.edit}
              data-testid={`${DATA_TEST_PRE}update-comment`}
            >
              {loading ? 'Updating...' : 'UPDATE'}
            </PrimaryButton>
          </Actions>

          {this.state.showEmojiPicker ? (
            <EmojiPicker
              onSelectEmoji={this.onSelectEmoji}
              closePicker={this.closePicker}
              data-testid={`${DATA_TEST_PRE}select-emoji`}
            />
          ) : null}
        </Form>
      </ModalContainer>
    );
  }
  render() {
    const { isOpen } = this.props;
    const styles = modalStyles(620);

    return (
      <Modal
        /* TODO(@mxstbr): Fix this */
        ariaHideApp={false}
        isOpen={isOpen}
        onRequestClose={this.close}
        shouldCloseOnOverlayClick={true}
        style={styles}
        closeTimeoutMS={330}
      >
        {this.renderModalContent()}
      </Modal>
    );
  }
}

const map = state => ({
  isOpen: state.modals.isOpen,
});
export default compose(
  // $FlowIssue
  connect(map),
  editMessageMutation,
  withCurrentUser,
  withRouter
)(EditCommentModal);
